import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import {Heading} from '@primer/react'
import type {ReactNode} from 'react'

import styles from './RepositoryProjects.module.css'

interface ProjectsActionsProps {
  heading: string
  trailing?: ReactNode
}

export function ProjectsActions({heading, trailing}: ProjectsActionsProps) {
  if (useRepoIssuesSidebarLayoutEnabled()) {
    return null
  }

  return (
    <div className={styles.buttonGrp}>
      <div className={styles.titleGroup}>
        <SidebarPageLayout.SidebarTrigger />
        <Heading as="h1" className={styles.heading}>
          {heading}
        </Heading>
      </div>
      {trailing}
    </div>
  )
}
